<template>
    <div :class="zone == 0 ? 'wave-navigation-component' : 'wave-navigation-component fix-to-top'">
        <a v-if="Number(currentWave) > 1 && zone != 0" :href="'/corona_microsite?wave=' + (Number(currentWave) - 1).toString()+(inFrame ? '&inframe=true' : '')" style="position:absolute;left:20px;">&lt;</a>
        <ul :style="'width:' + (waves.length * (zone == 0 ? buttonWidth * .65 : buttonWidth / 2)).toString() + 'px;'">
            <li :class="Number(currentWave) == i + 1 ? 'wave-item current-wave' : 'wave-item'" :style="'width:' + (zone == 0 ? buttonWidth * .65 : buttonWidth / 2).toString() + 'px;' + (Number(currentWave) == i + 1 ? 'background-color:' + w.color + ';' : '')" v-for="(w, i) in waves" :key="'waves' + i.toString()">
                <a :style="'color:' + w.color + ';cursor:pointer;'" :href="'/corona_microsite?wave=' + w.wave.toString()+(inFrame ? '&inframe=true' : '')" v-html="zone == 0 ? w.title.split(' ').join('<br />') : w.title.split(' ')[1]"></a>
                <label v-if="zone == 0" v-html="w.date.split(' ').join('<br />')"></label>
            </li>
        </ul>
        <a v-if="Number(currentWave) < waves[waves.length - 1].wave && zone != 0" :href="'/corona_microsite?wave=' + (Number(currentWave) + 1).toString()+(inFrame ? '&inframe=true' : '')" style="position:absolute;right:20px;">&gt;</a>
    </div>
</template>
<script>
import Sections from '../components/utils/Sections.js'
export default {
  props: ['zone'],
  data () {
    return {
      inFrame: Sections.inFrame(),
      currentWave: Sections.getWave(),
      waves: [
        {back: 2, date: 'March 13', title: 'WAVE I', color: 'rgb(120, 145, 59)', wave: 1},
        {back: 6, date: 'March 16', title: 'WAVE II', color: 'rgb(245, 135, 88)', wave: 2},
        {back: 11, date: 'March 19', title: 'WAVE III', color: 'rgb(152, 35, 103)', wave: 3},
        {back: 20, date: 'March 26', title: 'WAVE IV', color: 'rgb(103, 188, 193)', wave: 4},
        {back: 29, date: 'March 30', title: 'WAVE V', color: 'rgb(240, 153, 8)', wave: 5},
        {back: 38, date: 'April 1-2', title: 'WAVE VI', color: 'rgb(79, 95, 42)', wave: 6},
        {back: 48, date: 'April 4-6', title: 'WAVE VII', color: 'rgb(63, 178, 148)', wave: 7},
        {back: 59, date: 'April 10-13', title: 'WAVE VIII', color: 'rgb(245, 135, 88)', wave: 8},
        {back: 70, date: 'April 17-20', title: 'WAVE IX', color: 'rgb(78, 37, 64)', wave: 9},
        {back: 70, date: 'April 24-27', title: 'WAVE X', color: 'rgb(162, 203, 62)', wave: 10},
        {back: 70, date: 'May 1-4', title: 'WAVE XI', color: 'rgb(153, 52, 103)', wave: 11},
        {back: 70, date: 'May 7-11', title: 'WAVE XII', color: 'rgb(233, 184, 32)', wave: 12},
        {back: 70, date: 'May 14-18', title: 'WAVE XIII', color: 'rgb(63, 165, 165)', wave: 13},
        {back: 70, date: 'May 22-26', title: 'WAVE XIV', color: 'rgb(245, 135, 88)', wave: 14},
        {back: 70, date: 'May 28-31', title: 'WAVE XV', color: 'rgb(2, 116, 100)', wave: 15},
        {back: 70, date: 'June 4-8', title: 'WAVE XVI', color: 'rgb(153, 52, 103)', wave: 16},
        {back: 70, date: 'June 11-14', title: 'WAVE XVII', color: 'rgb(178, 182, 56)', wave: 17},
        {back: 70, date: 'June 18-22', title: 'WAVE XVIII', color: 'rgb(103, 168, 193)', wave: 18},
        {back: 70, date: 'June 25-29', title: 'WAVE XIX', color: 'rgb(236, 162, 39)', wave: 19}
      ],
      buttonWidth: 90
    }
  },
  methods: {
    gotoWave: function (back) {
      var listItems = document.querySelectorAll('.section-navigation > li.wave-item > a')
      listItems[listItems.length - back].click()
    }
  }    
}
</script>
<style lang="scss" scoped>
div.wave-navigation-component{
    position: absolute;
    width: 100%;
    left: 0;
    top:530px;
    z-index: 10000;
    > a{
      width: 30px;
      height: 30px;
      border-radius: 200px;
      padding: 0;
      text-align: center;
      font-size: 18px;
      background-color: #333;
      color: #fff;
      text-decoration: none;
      font-weight:bold;
      margin-top:10px;
    }
    > ul{
        margin: 0 auto;
        padding:0;
        max-width: 1200px;
        > li{
            display:inline-block;
            margin:0;
            padding:0;
            text-align: center;
            float:left;
            border-radius: 6px;
            > a{
                display:block;
                font-family:Gotham-Bold;
                font-size:13px;
                line-height: 1;
                padding-top: 8px;
                
            }
            > label{
                display: block;
                font-family:Gotham-Light;
                font-size: 10px;
                line-height: 1;
            }
        }
        > li.current-wave{
          background-color: rgba(210,210,210,.5);
          > a{
                color:#ffffff !important;
            }
            > label{
                color:#ffffff !important;
            }
        }
    }
    
}
div.wave-navigation-component.fix-to-top{
    position:fixed;
    top:0;
    background-color:rgba(255,255,255,.85);
    width: 100vw;
    box-shadow: 0 20px 10px #ffffff inset;
    > ul{
      > li{
        border-radius: 0;
        > a{
          font-size: 16px;
          padding: 18px 0;
          
        }
      }
    }
}
</style>


// WEBPACK FOOTER //
// src/custom/WaveNav.vue